/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-unused-prop-types */
import { useEffect, useRef } from 'react';
import { bool, func, node, object, oneOfType, string } from 'prop-types';
import { noop } from 'lodash';
import { ListItem, ListItemIcon, ListItemText, makeStyles } from '@material-ui/core';

import messageDescriptor from '../../lingui/LinguiPropTypes';
import MenuActions, { actionsType } from './MenuActions';
import Link from '../../links/Link';
import { linkType, useIsActive, useUrl } from './LinkUtilities';
import { RowFlexLayout } from '../../layout';
import { DEFAULT_INVALID_VALUE } from '../../../utilities/FormattingUtilities';

const useStyles = makeStyles((theme) => ({
    disabledGroupItem: {
        alignItems: 'center',
        color: theme.palette.text.secondary,
    },
}));

export default function MenuGroupItem({
    id,
    title,
    icon,
    link,
    disabled,
    actions,
    className,
    hoverText,
    onActiveChange,
    highlightChildLinks,
}) {
    const url = useUrl(link);
    const classes = useStyles();
    const isActive = useIsActive(link, { includeChildren: highlightChildLinks });

    const onActiveChangeRef = useRef();
    onActiveChangeRef.current = onActiveChange;

    const linkRef = useRef();
    linkRef.current = link;

    useEffect(() => {
        onActiveChangeRef.current(linkRef.current, isActive);
    }, [isActive]);

    const Wrapper = ({ children }) =>
        disabled ? (
            <RowFlexLayout className={classes.disabledGroupItem}>{children}</RowFlexLayout>
        ) : (
            <Link to={url} state={{ navFromSidebar: true }} plmIdDefault={link?.plmId}>
                {children}
            </Link>
        );

    return (
        <ListItem title={hoverText} id={`side-nav-item-${id}`} className={className} selected={isActive}>
            <Wrapper>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText>{title || DEFAULT_INVALID_VALUE}</ListItemText>
            </Wrapper>
            <MenuActions actions={actions} />
        </ListItem>
    );
}

MenuGroupItem.propTypes = {
    id: string.isRequired,
    className: string,
    title: oneOfType([string, messageDescriptor]).isRequired,
    icon: node.isRequired,
    link: linkType.isRequired,
    highlightChildLinks: bool,
    actions: actionsType,
    dragItem: object,
    hoverText: string,
    onActiveChange: func,
    disabled: bool,
};

MenuGroupItem.defaultProps = {
    className: undefined,
    actions: undefined,
    dragItem: undefined,
    hoverText: undefined,
    onActiveChange: noop,
    highlightChildLinks: false,
    disabled: false,
};
